import React, { useState, useEffect } from "react";
import NavBar from "../../components/NavBar/NavBar";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { WithContext as ReactTags } from "react-tag-input";
import Swal from "sweetalert2";
import {
  CityListAPI,
  getParentListAPI,
  MasterSchoolBoardListAPI,
  SchoolListAPI,
  upsertPromocode,
} from "../../api/apiHandler";
import moment from "moment";
import { discountTypeOption } from "../Common/CommonFunctions";
import Modal from "react-modal";
import Heading from "../../components/Heading/Heading";

const schema = yup.object().shape({
  name: yup.string().required("Please enter name"),
  unique_code: yup.string().required("Please enter unique code"),
  promotion_sponsor_code: yup
    .string()
    .required("Please enter promotion sponsor code"),
  usage_limit: yup.string().required("Please enter usage limit"),
  discount_type: yup.string().required("Please enter discount type"),
  discount_value: yup.number().required().min(0, "Must be more than 0"),
  max_discount_amount: yup.number().when("discount_type", {
      is: "PERCENTAGE" || "FREE_MEAL",
      then: (schema) =>
        schema
        .required("Please enter max discount amount")
        .min(0, "Must be more than 0"),
      otherwise: (schema) => schema.notRequired(),
  }),
  minimum_order_value: yup.number().required().min(0, "Must be more than 0"),
  description: yup.string().required("Please enter description"),
  //   valid_upto: yup.array().of(yup.string().required("Please select dates")).required("Please select dates"),
   tags: yup.array().when("promo_code_type", {
    is: (val) => val !== "ALL",  // only validate if not ALL
    then: (schema) => schema.min(1, "Please select at least one."),
    otherwise: (schema) => schema.notRequired(),
  }),
});

function EditPromocode() {
  const navigate = useNavigate();

  const location = useLocation();
  const promoData = location.state;
  const getPromoType = promoData.promo_code_type || "ALL";
  const [walletModal, setWalletModal] = useState(false);
  const [totalAmount, setTotalAmount] = useState();
  const [difference, setDifference] = useState(0);
  const [differenceType, setDifferenceType] = useState(""); 
  const [oldTotal] = useState(Number(promoData.total_amount) || 0); 
  const [walletType] = useState(promoData.credit_source_wallet); 


  const formatLabel = (text) => {
  if (!text) return "";
  return text
    .toLowerCase()
    .replace(/_/g, " ") 
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
  const formattedTags =
     getPromoType === "PARENT"
     ? (promoData.parent_array?.map((tag) => ({
         id: String(tag.id) || "",
        text: tag.email || "",
       })) || [])
      : getPromoType === "SCHOOL"
      ? (promoData.schools_array?.map((tag) => ({
          id: String(tag.id) || "",
          text: tag.school_name || "",
        })) || [])
      : getPromoType === "SCHOOL_BOARD"
      ?(promoData.school_board_array?.map((tag) => ({
         id: (tag.school_board ? tag.school_board.trim() : "" ), 
         text: (tag.school_board || "Unknown School Board"),
      }))|| [])
      : getPromoType === "CITY"
      ? (promoData?.city_array?.map((tag) => ({
          id: String(tag.id) || "",
          text: tag.city_name || "",
      })) || [] )
      : [];

  const [tags, setTags] = useState(formattedTags || []);

  const selectedDiscountType = discountTypeOption.find(
    (x) => x.label === promoData.discount_type
  );
  const startDate = moment(promoData?.valid_from).toDate();
  const endDate = moment(promoData?.valid_to).toDate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    getValues,
    watch,
    trigger,
  } = useForm({
    defaultValues: {
      tags: formattedTags || [],
      promo_code_type: getPromoType,
    },
    resolver: yupResolver(schema),
  });
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [dateRange, setDateRange] = useState([startDate, endDate]);
  const [first, setFirst] = useState(0);
  const [validFrom, validTo] = dateRange;
  const [parents, setParents] = useState([]);
  const [schools, setSchools] = useState([]);
  const [city, setCity] = useState([]);
  const [masterSchoolBoards, setMasterSchoolBoards] = useState([]);
  const [discountType, setDiscountType] = useState(selectedDiscountType);
  const [schoolOrParent, setSchoolOrParent] = useState(getPromoType);
  const donor_id= localStorage.getItem("DAid");

  const fetchParents = async () => {
    let pageInfo = {
      limit: 5000,
    };
    const response = await getParentListAPI(pageInfo);
    if (response.data.code === "1") {
      setParents(response.data.data.data || []);
    } else {
      setParents([]);
    }
  };
  const fetchSchools = async () => {
    const response = await SchoolListAPI();
    if (response.data.code === "1") {
      setSchools(response.data.data || []);
    } else {
      setSchools([]);
    }
  };
  const fetchSchoolBoards = async () => {
    try{
    let pageInfo = {
      limit: 5000,
    };
    const response = await MasterSchoolBoardListAPI(pageInfo);
    if (response.data.code === "1") {
      setMasterSchoolBoards(response.data.data.data);
    }
    }catch (e){
      console.error("Error fetching schoolBoard:", e);
      setMasterSchoolBoards([]);
    }
  };
  const fetchCity = async () => {
    try{
    let pageInfo = {
      allActiveItems : true
    };
    const response = await CityListAPI(pageInfo);
    if (response.data.code === "1") {
      setCity(response.data.data.data);
    }
    }catch (e){
      console.error("Error fetching schoolBoard:", e);
      setCity([]);
    }
  };
// -------------------------------
  // Helper to derive parent IDs from promoData in various formats
  const deriveIds = () => {
    if (Array.isArray(promoData?.parent_array) && promoData.parent_array.length ) {
      return promoData.parent_array.map((x) => x.id);
    }
    const raw = promoData?.parent ;
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "string") {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        // Not JSON; try comma-separated list
        return raw
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
          .map((s) => parseInt(s))
          .filter((n) => !isNaN(n));
      }
    }
    return [];
  };

  useEffect(() => {
    if (getPromoType !== "PARENT") return;
    const ids = deriveIds();
    if (!ids.length) return;
    const selected = ids.map((id) => {
      if (getPromoType === "PARENT") {
      const p = parents.find((x) => String(x.id) === String(id));
      return { id: String(id), text: p?.email || String(id) };
      } 
    });
    setTags(selected);
    setValue("tags", selected, { shouldValidate: true, shouldDirty: true });
  }, [getPromoType, parents]);
// ---------------------------------------------
  const setPromoDetail = async () => {
    setValue("name", promoData.name);
    setValue("unique_code", promoData.unique_code);
    setValue("promotion_sponsor_code", promoData.promotion_sponsor_code);
    setValue("usage_limit", promoData.usage_limit);
    setValue("discount_type", promoData.discount_type);
    setValue("discount_value", promoData.discount_value);
    setValue("minimum_order_value", promoData.minimum_order_value);
    setValue("description", promoData.description);
    setValue("allow_multiple_uses", promoData.allow_multiple_uses);
    setValue("promo_code_type", getPromoType);
    setValue(
      "no_of_meals_for_meals_based_discount",
      promoData.no_of_meals_for_meals_based_discount
    );
    setValue("max_discount_amount", promoData.max_discount_amount);
    setTotalAmount( promoData.total_amount);
  };

  useEffect(() => {
   
    if (getPromoType === "PARENT") {
   fetchParents();
    }
    if (getPromoType === "SCHOOL") {
      fetchSchools();
    }
    if(getPromoType === "SCHOOL_BOARD"){
      fetchSchoolBoards();
    }
    if(getPromoType === "CITY"){
      fetchCity();
    }
    setPromoDetail();
  }, []);

  const parentSuggestions = parents.map((p) => ({
    id: String(p.id || ""),
    text: p.email || "Unknown Parent",
  }));

  const boardSuggestions = masterSchoolBoards.map((b) => ({
    id: (b.school_board ? b.school_board.trim() : "" ), 
    text: (b.school_board || "Unknown School Board"),
    schools: (() => {
      try {
        return JSON.parse(b?.schools || "[]");
      } catch (e) {
        return [];
      }
    })(),
  }));

  const schoolSuggestions = schools.map((s) => ({
    id: String(s.master_school_id || ""),
    text: s.school_name || "Unknown School",
    email: s.email || "",
    school_id: s.id || "",
  }));

  const citySuggetions = city.map((c) => ({
    id: String(c?.id || ""),
    text: c?.city_name || "Unknown City",
    schools : c?.schools || [],
  }));

  const suggestions =
    schoolOrParent === "PARENT"
      ? parentSuggestions
      : schoolOrParent === "SCHOOL"
      ? schoolSuggestions
      : schoolOrParent === "SCHOOL_BOARD"
      ? boardSuggestions
      : schoolOrParent === "CITY"
      ? citySuggetions
      : [];
    ; //

  const handleDelete = (index) => {
    const updatedTags = tags.filter((_, i) => i !== index);
    syncTagsWithForm(updatedTags);
  };

  const handleAddition = (tag) => {
    const safeTags = Array.isArray(tags) ? tags : [];
    const updatedTags = [...safeTags, tag];
    syncTagsWithForm(updatedTags);
  };

  const syncTagsWithForm = (updatedTags) => {
    const safe = Array.isArray(updatedTags) ? updatedTags : [];
    setTags(safe);
    setValue("tags", [...safe], { shouldValidate: true, shouldDirty: true });
  };

  const handleDrag = (tag, currPos, newPos) => {
    const base = Array.isArray(tags) ? tags : [];
    const newTags = base.slice();
    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    setTags(newTags);
  };

  const handleOnRadioChange = (type) => {
    onClearAll();
    setSchoolOrParent(type);
    if (type === "PARENT") fetchParents();
    if (type === "SCHOOL") fetchSchools();
    if (type === "SCHOOL_BOARD") fetchSchoolBoards();
    if (type === "CITY") fetchCity();
  };

  const onClearAll = () => {
    setTags([]);
    setValue("tags", [], { shouldValidate: true, shouldDirty: true });
  };

  const label = () => {
    let text = "";
    let type = discountType.value;
    if (type === "FREE_MEAL") {
      text = "No of free meal";
    } else if (
      type === "PERCENTAGE"
    ) {
      text = "Percentage";
    } else {
      text = "Discount value";
    }
    return text;
  };
  const total_amount_calculate = () => {
    const discountType = getValues("discount_type");
    const discountValue = Number(getValues("discount_value")) || 0;
    const maxDiscountAmount = Number(getValues("max_discount_amount")) || 0;
    const usageLimit = Number(getValues("usage_limit")) || 0;

    let total = 0;
    if (discountType === "FLAT_AMOUNT") total = discountValue * usageLimit;
    else if (discountType === "PERCENTAGE") total = maxDiscountAmount * usageLimit;
    else if (discountType === "FREE_MEAL") total = maxDiscountAmount * usageLimit ;
    setTotalAmount(total);

    const diff = total - oldTotal;
    setDifference(Math.abs(diff));
    setDifferenceType(diff < 0 ? "refund" : diff > 0 ? "pay" : "");
  };

  const watchDiscountType = watch("discount_type");
  const watchDiscountValue = watch("discount_value");
  const watchMaxDiscountAmount = watch("max_discount_amount");
  const watchUsageLimit = watch("usage_limit");

  useEffect(() => {
    total_amount_calculate();
  }, [watchDiscountType, watchDiscountValue, watchMaxDiscountAmount, watchUsageLimit]);

  const handleWalletSubmit = async () => {
    setWalletModal(false);
    const formData = getValues();
    const submitData = { ...formData, wallet_type: walletType, total_amount: totalAmount };
    await onSubmit(submitData);
  };

  const onSubmit = async (submitData) => {
   const selectedIds =
      schoolOrParent === "SCHOOL_BOARD"
      ? tags.map((t) => t.text) 
      : tags.map((t) => parseInt(t.id));
    let req = {
        difference: difference,
        difference_type: differenceType,
        donor_id: donor_id,
        promocode_id: promoData.promocode_id,   
        parent: schoolOrParent === "PARENT" ? selectedIds : [],
        school: schoolOrParent === "SCHOOL" ? selectedIds : [],
        city : schoolOrParent === "CITY" ? selectedIds : [],
        school_board: schoolOrParent === "SCHOOL_BOARD" ? selectedIds : [],
        valid_from: moment(validFrom).format("YYYY-MM-DD"),
        valid_to: moment(validTo).format("YYYY-MM-DD"),
        all_selected: schoolOrParent === "ALL",
        promo_code_type: schoolOrParent ,
        create_by_type : "DONOR",
    };

    let requestData = { ...submitData, ...req };

    const response = await upsertPromocode(requestData);

    if (response.data.code === "1") {
      reset();
      onClearAll();
      Swal.fire("Food For Good", response.data.message, "success").then(
        (result) => {
          navigate("/manage-promocode");
        }
      );
    } else {
      Swal.fire("Food For Good", response.data.message, "error");
    }
  };

  return (
    <>
      <NavBar />
      <section className="content home">
        <Heading title="Edit Promocode" />
        <div className="container-fluid">
          <div className="row clearfix">
            <div className="col-lg-12">
              <div className="card">
                <div className="body">
                  <div className="row">
                    <div className="preview col-md-12">
                      <div className="preview-pic tab-content">
                        <div className="tab-pane active" id="product_1"></div>
                      </div>
                    </div>
                    <div className="details col-lg-8 col-md-12">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="col-sm-12 pl-3">
                          <div className="form-group">
                            <div className="form-line">
                              <p style={{ marginBottom: "0px" }}>Name</p>
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                {...register("name")}
                              />
                            </div>
                            <p className="mt-2 font-bold col-red">
                              {errors.name?.message}
                            </p>
                          </div>

                          <div className="form-group">
                            <div className="form-line">
                              <p style={{ marginBottom: "0px" }}>Unique code</p>
                              <input
                                type="text"
                                className="form-control"
                                name="unique_code"
                                {...register("unique_code")}
                                disabled
                              />
                            </div>
                            <p className="mt-2 font-bold col-red">
                              {errors.unique_code?.message}
                            </p>
                          </div>

                          <div className="form-group">
                            <div className="form-line">
                              <p style={{ marginBottom: "0px" }}>
                                Discount type
                              </p>
                              <Select
                                options={discountTypeOption}
                                placeholder={"Discount type"}
                                onChange={(e) => {
                                  setDiscountType(e);
                                  setValue("discount_type", e?.value, {
                                    shouldValidate: true,
                                  });
                                  label(e?.value);
                                }}
                                className="form-control"
                                value={promoData.discountType || discountType}
                                isClearable
                              />
                              <input
                                type="hidden"
                                className="form-control"
                                name="discount_type"
                                {...register("discount_type")}
                              />
                            </div>
                            <p className="mt-2 font-bold col-red">
                              {errors.discount_type?.message}
                            </p>
                          </div>
                          <div className="form-group">
                            <div className="form-line">
                              <p style={{ marginBottom: "0px" }}>{label()}</p>
                              <input
                                type="number"
                                className="form-control"
                                name="discount_value"
                                {...register("discount_value")}
                                defaultValue={0}
                                min={1}
                              />
                            </div>
                            <p className="mt-2 font-bold col-red">
                              {errors.discount_value?.message}
                            </p>
                          </div>
                           {(discountType?.value === "PERCENTAGE" || discountType?.value === "FREE_MEAL") ? (
                            <div className="form-group">
                              <div className="form-line">
                                <p style={{ marginBottom: "0px" }}>
                                  Max discount amount
                                </p>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="max_discount_amount"
                                  {...register("max_discount_amount")}
                                  min={1}
                                />
                              </div>
                              <p className="mt-2 font-bold col-red">
                                {errors.max_discount_amount?.message}
                              </p>
                            </div>

                          ) : (
                            ""
                          )}
                          <div className="form-group">
                            <div className="form-line">
                              <p style={{ marginBottom: "0px" }}>
                                Promotion sponsor code
                              </p>
                              <input
                                type="text"
                                className="form-control"
                                name="promotion_sponsor_code"
                                {...register("promotion_sponsor_code")}
                              />
                            </div>
                            <p className="mt-2 font-bold col-red">
                              {errors.promotion_sponsor_code?.message}
                            </p>
                          </div>

                          <div className="form-group">
                            <div className="form-line">
                              <p style={{ marginBottom: "0px" }}>Usage Limit</p>
                              <input
                                type="number"
                                className="form-control"
                                name="usage_limit"
                                {...register("usage_limit")}
                                min={0}
                              />
                            </div>
                            <p className="mt-2 font-bold col-red">
                              {errors.usage_limit?.message}
                            </p>
                          </div>

                          <div className="form-group">
                            <div className="form-line">
                              <p style={{ marginBottom: "0px" }}>Valid Upto</p>
                              <DatePicker
                                dateFormat="dd-MM-yyyy"
                                selectsRange={true}
                                startDate={validFrom}
                                endDate={validTo}
                                onChange={(update) => {
                                  setDateRange(update);
                                  setValue("valid_upto", update, {
                                    shouldValidate: true,
                                  });
                                  setPage(1);
                                  setFirst(0);
                                }}
                                placeholderText="Select Date"
                                className="form-control"
                                isClearable={true}
                              />
                            </div>
                            <input
                              type="hidden"
                              className="form-control"
                              name="valid_upto"
                              {...register("valid_upto")}
                            />
                            <p className="mt-2 font-bold col-red">
                              {errors.valid_upto?.message}
                            </p>
                          </div>

                          <div className="form-group">
                            <p>Allow multiple times</p>
                            <input
                              type="checkbox"
                              id="checkbox_penuts"
                              className="filled-in"
                              {...register("allow_multiple_uses")}
                            />
                            <label
                              for="checkbox_penuts"
                              className="mr-1"
                            ></label>
                            <p className="mt-2 font-bold col-red">
                              {errors.allow_multi_time?.message}
                            </p>
                          </div>

                          <div className="form-group">
                            <h4 style={{ marginBottom: "8px" }}>
                              Promocode Type
                            </h4>

                            <input
                              type="radio"
                              name="promo_code_type"
                              value="ALL"
                              id="all"
                              {...register("promo_code_type")}
                              onChange={(e) =>
                                handleOnRadioChange(e?.target?.value)
                              }
                              defaultChecked={getPromoType === "ALL"}
                            />
                            <label htmlFor="all">All</label>
                            <input
                              type="radio"
                              name="promo_code_type"
                              value="SCHOOL_BOARD"
                              id="school_board"
                              {...register("promo_code_type")}
                              onChange = {(e) =>
                                handleOnRadioChange(e.target.value)
                              }
                              defaultChecked={getPromoType === "SCHOOL_BOARD"}
                            />
                            <label htmlFor="school_board">School Board</label>
                            <input
                              type="radio"
                              name="promo_code_type"
                              value="CITY"
                              id="school_city"
                              {...register("promo_code_type")}
                              onChange = {(e) =>
                                handleOnRadioChange(e.target.value)
                              }
                              defaultChecked={getPromoType === "CITY"}
                            />
                            <label htmlFor="school_city">City</label>
                            <input
                              type="radio"
                              name="promo_code_type"
                              value="SCHOOL"
                              id="school_school"
                              {...register("promo_code_type")}
                              onChange = {(e) =>
                                handleOnRadioChange(e.target.value)
                              }
                              defaultChecked={getPromoType === "SCHOOL"}
                            />
                            <label htmlFor="school_school">School</label>
                            <input
                              type="radio"
                              name="promo_code_type"
                              value="PARENT"
                              id="parent"
                              {...register("promo_code_type")}
                              onChange={(e) =>
                                handleOnRadioChange(e?.target?.value)
                              }
                              defaultChecked={getPromoType === "PARENT"}
                            />
                            <label htmlFor="parent">Parent</label>
                          </div>
                          {schoolOrParent !== "ALL" && (
                            <div className="form-group">
                              <div className="form-line">
                                <h4 style={{ marginBottom: "8px" }}>
                                  Add {formatLabel(schoolOrParent)}
                                </h4>
                                <div style={{ position: "relative" }}>
                                  <ReactTags
                                    tags={tags}
                                    suggestions={suggestions}
                                    handleDelete={handleDelete}
                                    handleAddition={handleAddition}
                                    handleDrag={handleDrag}
                                    inputFieldPosition="bottom"
                                    placeholder={`Select to add ${formatLabel(schoolOrParent)}`}
                                    classNames={{
                                      tagInput: "form-control tag-input",
                                      tag: "tag-item",
                                      tagInputField: "tag-input-field",
                                      selected: "selected-tags",
                                      suggestions: "tag-suggestions",
                                      remove:
                                        "react-tags__remove ReactTags__remove ml-2 cursor-pointer text-red-500 hover:text-red-700",
                                    }}
                                    editable
                                    clearAll
                                    onClearAll={onClearAll}
                                  />
                                  <input
                                    type="hidden"
                                    className="form-control"
                                    name="tags"
                                    {...register("tags")}
                                  />
                                </div>
                              </div>
                              <p className="mt-2 font-bold col-red">
                                {errors?.tags?.message}
                              </p>
                            </div>
                          )}
                          <div className="form-group">
                            <div className="form-line">
                              <p
                                style={{
                                  marginBottom: "0px",
                                  marginTop: "50px",
                                }}
                              >
                                Minimum Order value
                              </p>
                              <input
                                type="number"
                                className="form-control"
                                name="minimum_order_value"
                                {...register("minimum_order_value")}
                                defaultValue={0}
                                min={0}
                              />
                            </div>
                            <p className="mt-2 font-bold col-red">
                              {errors.minimum_order_value?.message}
                            </p>
                          </div>
                          <div className="form-group">
                            <div className="form-line">
                              <p style={{ marginBottom: "0px" }}>Promotion Description</p>
                              <input
                                type="text"
                                className="form-control"
                                name="description"
                                {...register("description")}
                              />
                            </div>
                            <p className="mt-2 font-bold col-red">
                              {errors.description?.message}
                            </p>
                          </div>
                          <button
                            type="button"
                            className="btn btn-raised btn-primary m-t-15 waves-effect"
                            onClick={async () => {
                              const isValid = await trigger(); 
                              if (isValid) {
                                setWalletModal(true); 
                              } else {
                                setWalletModal(false)
                              }
                            }}
                          >
                            Update Promocode
                          </button>
                        </div>
                      </form>
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        isOpen={walletModal}
        onRequestClose={() => setWalletModal(false)}
        style={{
          content: {
            width: "450px",
            height: "310px",
            margin: "auto",
            borderRadius: "12px",
            padding: "30px",
            border: "none",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",

          },
          overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
        }}
      >
        <div className="modal-header border-0 justify-content-center align-items-center mb-2">
          <h5 className="mb-0 fw-bold text-dark">Confirm Update</h5>
        </div>
        <div className="modal-body ">
          <p><b>Wallet Type:</b> {formatLabel(walletType)}</p>
          <p><b>Old Total:</b> ₹{oldTotal.toFixed(2)}</p>
          <p><b>New Total:</b> ₹{totalAmount?.toFixed(2)}</p>
          {differenceType && (
            <p
              style={{
                color: differenceType === "refund" ? "green" : "red",
                fontWeight: "bold",
              }}
            >
              {differenceType === "refund"
                ? `Refund ₹${difference.toFixed(2)} will be processed.`
                : `You need to pay ₹${difference.toFixed(2)}.`}
            </p>
          )}
        </div>
        <div className="modal-footer d-flex justify-content-center gap-2">
          <button
            className="btn btn-secondary"
            onClick={() => setWalletModal(false)}
          >
            Cancel
          </button>
          <button className="btn btn-success" onClick={handleWalletSubmit}>
            Confirm Update
          </button>
        </div>
      </Modal>
    </>
  );
}

export default EditPromocode;